import { TrashSimple } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { usePartFinderFamilyActions } from 'companySettings/hooks';
import { IPartFinderFamily } from 'companySettings/types';
import { Button, Confirmation } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { useAgGridClientTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

// Removing is never blocked: the families leave the list and the finder.
export const RemovePartFinderFamiliesButton = () => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const { t } = useTranslation();

  const { selectedRows, updateRows } = useAgGridClientTableContext();
  const { removePartFinderFamilies } = usePartFinderFamilyActions(NotificationPosition.TOP);

  const families = (selectedRows ?? []) as IPartFinderFamily[];

  const onRemove = async () => {
    setIsConfirmationOpen(false);

    const { success } = await removePartFinderFamilies(families.map((family) => family.id));

    if (!success) {
      return;
    }

    updateRows({ remove: families });
  };

  return (
    <>
      <Button
        text={t('buttonLabelRemove')}
        variant={Variant.SOFT}
        color={Color.DANGER}
        startDecorator={<TrashSimple />}
        onClick={() => setIsConfirmationOpen(true)}
      />

      <Confirmation
        isOpen={isConfirmationOpen}
        color={Color.WARNING}
        title={t('titleRemovePartFinderFamilies', { count: families.length })}
        message={t('messageConfirmRemovePartFinderFamilies', {
          count: families.length,
          name: families[0]?.name,
        })}
        confirmBtnLabel={t('buttonLabelRemove')}
        confirmBtnColor={Color.DANGER}
        onConfirm={onRemove}
        onCancel={() => setIsConfirmationOpen(false)}
      />
    </>
  );
};
